module.exports = __webpack_public_path__ + "static/assets/f5833a4fc0a3ac596498c52a69f6155f.svg";